import { IoIosCheckmarkCircle, IoMdCloseCircle } from 'react-icons/io';

export const getBooleanValueIcon = (value: string | null) => {
    if (value === 'true') {
        return <IoIosCheckmarkCircle />;
    } else if (value === 'false') {
        return <IoMdCloseCircle />;
    } else return null;
};
